import React, { Component } from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import withTracker from '../lib/withTracker'
import withStore from '../lib/withStore'
import withHeader from '../lib/withHeader'
import QRCode from 'qrcode.react'
import I18n from '../lib/i18n'
import * as StyledComponent from '../styles'
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core/'
import IconArrowDown from '../images/icon_arrow_down.svg'
import EmptyPageContainer from '../components/EmptyPageContainer'
import PageMiddleSpinner from '../components/PageMiddleSpinner'

class OrderHistory extends Component {
  state = {
    loading: true
  }

  browseProductGroups = () => {
    this.props.history.push(`/${I18n.currentLocale()}/products`)
  }

  componentDidMount() {    
    this.props.store.checkOrdersStatus()

    if (this.getParams('error_message')) {
      this.props.history.push(`/${I18n.currentLocale()}`)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.store.loading_orders && this.state.loading) {
      this.setState({ loading: false })
    }
  }

  getParams = (key) => {
    const params = new URLSearchParams(window.location.search)

    return params.get(key)
  }

  render() {
    const { loading_orders, orders } = this.props.store
    const sorted_orders = _.sortBy(orders, ['id'])
    // otherwise, show rsvp shorten url for event checkout purpose
    const qrcode_props = {
      bgColor: '#ffffff',
      className: 'qrcode',
      fgColor: '#000000',
      size: 200,
    }

    if (this.state.loading) {
      return <PageMiddleSpinner loading={true} />
    } else if (_.isEmpty(orders) && !loading_orders) {
      return <EmptyPageContainer
        message={I18n.t('containers.order_list.empty_message')}
        buttons={[{
          onClick: this.browseProductGroups,
          text: I18n.t('containers.cart.shop_now')
        }]} />
    } else {
      return <StyledComponent.PageContainer id='scroll-view'>
        <StyledComponent.OrderHistory>
          <div className='title-container'>
            <h5>{I18n.t('containers.order_list.title')}</h5>
          </div>
          {
            // show order qrcode
            sorted_orders.map(order => <ExpansionPanel className='order-container' key={`order-${order.id}`}>
              <ExpansionPanelSummary expandIcon={<img height={8} src={IconArrowDown} alt='expand' />} className='order-summary'>
                <h5>{ I18n.t('containers.order_list.ticket_number', { ticket_number: order.shipments[0].ticket_number }) }</h5>
                <div>
                  { I18n.t(`containers.order_list.order_state.${order.shipments[0].state === 'ready_to_receive' ? 'ready_for_collection' : 'in_progress'}`) }
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className='order-details'>
                <React.Fragment>
                  <div className='order-details-container'>
                    <div
                      className='thank-you-title'
                      dangerouslySetInnerHTML={{ __html:
                        I18n.t(`containers.order_list.${order.shipments[0].state === 'ready_to_receive'
                          ? 'order_ready_title'
                          : 'thank_you_title'}`)
                        }}
                    />
                    <div className="collect-message">
                      {
                        order.payment_state === 'payment_deferred'
                          ? I18n.t(`containers.order_list.pay_and_collect_message`)
                          : I18n.t(`containers.order_list.collect_message`)
                      }
                    </div>
                    <div className='ticket-no-label'>{I18n.t('containers.order_list.ticket_no_label')}</div>
                    <div className='ticket-no'>{order.shipments[0].ticket_number}</div>
                    <div className='qrcode-container'>
                      <QRCode {...qrcode_props}  value={order.shipments[0].store_pickup_qr_code_value} />
                    </div>
                  </div>
                  <div className='qr-code-message-container'>
                    <div className='qrcode_message' dangerouslySetInnerHTML={{ __html: I18n.t('containers.order_list.qrcode_message')}} />
                  </div>
                </React.Fragment>
              </ExpansionPanelDetails>
            </ExpansionPanel>)
          }
        </StyledComponent.OrderHistory>
      </StyledComponent.PageContainer>
    }
  }
}

export default withTracker(withStore(withRouter(withHeader(OrderHistory))), {
  title: I18n.t('containers.order_list.title')
})



// WEBPACK FOOTER //
// ./src/containers/OrderHistory.js